import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { terminal } from './app/terminal.js';
import './styles.css';

const container = document.getElementById('root');
if (container === null) throw new Error('the terminal needs a #root element');

// Boot before the first render so a stored session starts connecting without a
// mount/unmount race (React 19's StrictMode would run the effect twice; a second
// socket with the same cursor means a second replay, so this app does not use it
// and the connection lives outside React's lifecycle on purpose).
terminal.start();

createRoot(container).render(<App />);
